import React from 'react';
import PropTypes from 'prop-types';

const SvgExitFullScreen = ({ active, ...props }) => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="26" height="26" fill="none" viewBox="0 0 26 26" {...props}>
            <rect width="24.2" height="24.2" x="1" y="1" fill="#EAEBF0" stroke="#343A72" strokeWidth="1.25" rx="4" />
            <path
                stroke="#343A72"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="1.25"
                d="m5.4 20.8 3.3-3.3m-2.75 0H8.7v2.75m12.1.55-3.3-3.3m2.75 0H17.5v2.75M5.4 5.4l3.3 3.3m-2.75 0H8.7V5.95m12.1-.55-3.3 3.3m2.75 0H17.5V5.95"
            />
        </svg>
    );
};
SvgExitFullScreen.propTypes = {
    active: PropTypes.bool,
};
SvgExitFullScreen.defaultProps = {
    active: false,
};

export default SvgExitFullScreen;
